import { render, staticRenderFns } from "./TopAbout.vue?vue&type=template&id=1c16f16d&scoped=true&"
import script from "./TopAbout.vue?vue&type=script&lang=js&"
export * from "./TopAbout.vue?vue&type=script&lang=js&"
import style0 from "./TopAbout.vue?vue&type=style&index=0&id=1c16f16d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c16f16d",
  null
  
)

export default component.exports